import { render, staticRenderFns } from "./message_list.vue?vue&type=template&id=3f41a6f7&scoped=true"
import script from "./message_list.vue?vue&type=script&lang=js"
export * from "./message_list.vue?vue&type=script&lang=js"
import style0 from "./message_list.vue?vue&type=style&index=0&id=3f41a6f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f41a6f7",
  null
  
)

export default component.exports